import Icon from "@/common/components/Icon";

const TableHeaderWithSort = ({ displayName, sortFunction }) => {
	return (
		<span>
			{displayName}{' '}
			<Icon
				name='chevron-down'
				onClick={sortFunction}
				style={{ cursor: 'pointer', color:'white' }}
			/>
		</span>
	);
};

export default TableHeaderWithSort;
